import ChartJsChartContainer from "../../components/charts/chartJsChart";

const ChartJs = () => {
  return <ChartJsChartContainer />;
};

export default ChartJs;
